import React, { Children, Component, useEffect, useRef } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { motion } from 'framer-motion';
import { benefitIconMap } from '../ui/icons/BenefitIcons';
import { trackViewContent } from '../../utils/metaPixel';
export function Benefits() {
  const {
    t
  } = useLanguage();
  const sectionRef = useRef<HTMLElement | null>(null);
  const viewContentFiredRef = useRef(false);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !viewContentFiredRef.current) {
          viewContentFiredRef.current = true;
          trackViewContent({
            section: 'benefits'
          });
        }
      });
    }, {
      threshold: 0.3
    });
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);
  const items: {
    title: string;
    desc: string;
    key: string;
  }[] = t('benefits.items');
  const easeOutCubic = [0.33, 1, 0.68, 1];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: easeOutCubic
      }
    }
  };
  return <section id="beneficios" ref={sectionRef} className="py-20 lg:py-28 bg-white" data-id="element-49" data-mp="6g9lgseatpxj">
      <div className="container mx-auto px-6" data-id="element-50" data-mp="3su1155edqr9i">
        <div className="text-center max-w-2xl mx-auto mb-14" data-id="element-51" data-mp="3suswqg7z8ozs">
          <span className="text-brand-dark/50 font-medium tracking-[0.25em] text-xs uppercase mb-6 block" data-id="element-52" data-mp="3nv6l2b7srgt3">
            {t('benefits.eyebrow')}
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-light text-brand-dark mb-6 tracking-tight" data-id="element-53" data-mp="3iv1zw7vy1xwj">
            {t('benefits.heading')}
          </h2>
          <p className="text-brand-dark/60 font-light text-lg" data-id="element-54" data-mp="3483asjkk7fkz">
            {t('benefits.subheading')}
          </p>
          <div className="w-12 h-px bg-brand-gold mx-auto mt-10" data-id="element-55" data-mp="399so65v985c8"></div>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-16" data-id="element-56" data-mp="2v9rp8vyjv7ze">
          {items.map(item => {
          const IconComponent = benefitIconMap[item.key];
          return <motion.div key={item.key} variants={itemVariants} className="flex flex-col items-start group" data-id="element-57" data-mp="3e72d7keqeezj">
                <div className="mb-6 text-brand-dark/40 group-hover:text-brand-gold transition-colors duration-500" data-id="element-58" data-mp="apkec2gxsib9">
                  {IconComponent && <IconComponent className="w-8 h-8" strokeWidth={1} data-id="element-59" data-mp="ow461lkzz60v" />}
                </div>
                <h3 className="text-xl font-serif font-normal text-brand-dark mb-3" data-id="element-60" data-mp="kv26t4r2ytyw">
                  {item.title}
                </h3>
                <p className="text-brand-dark/60 font-light leading-relaxed" data-id="element-61" data-mp="ylff587vwaor">
                  {item.desc}
                </p>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}